module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-nissan.4ee2c4a5.jpg";